// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"NY-z","subtitle":"OY-z","wrapper":"PY-z","leftArrow":"QY-z","rightArrow":"RY-z"};